import axios from 'axios';
import config from '../config';

const API_URL = config.API_BASE_URL;

// Get all pending transactions (filtered by branch if needed)
export const fetchPendingTransactions = async (branchId = null) => {
  const url = branchId 
    ? `${API_URL}/Transactions/pending?branchId=${branchId}`
    : `${API_URL}/Transactions/pending`;
  const response = await axios.get(url);
  return response.data;
};

// Get transaction by ID
export const fetchTransactionById = async (id) => {
  const response = await axios.get(`${API_URL}/Transactions/${id}`);
  return response.data;
};

// Get transaction by order ID
export const fetchTransactionByOrderId = async (orderId) => {
  const response = await axios.get(`${API_URL}/Transactions/order/${orderId}`);
  return response.data;
};

// Get transactions for a user
export const fetchUserTransactions = async (userId) => {
  const response = await axios.get(`${API_URL}/Transactions/user/${userId}`);
  return response.data;
};

// Approve transaction
export const approveTransaction = async (id, approvedBy = null, notes = '', adminId = null, adminName = null) => {
  const response = await axios.put(`${API_URL}/Transactions/${id}/approve`, {
    approvedBy, // Legacy (can be null)
    notes,
    adminId,    // Current admin ID
    adminName   // Current admin name
  });
  return response.data;
};

// Get all transactions (history) with pagination
export const fetchAllTransactions = async (branchId = null, status = null, page = 1, limit = 50) => {
  let url = `${API_URL}/Transactions/all?page=${page}&limit=${limit}`;
  if (branchId) url += `&branchId=${branchId}`;
  if (status) url += `&status=${status}`;
  
  const response = await axios.get(url);
  return response.data;
};


// Reject transaction
export const rejectTransaction = async (id, approvedBy = null, rejectionReason, notes = '', adminId = null, adminName = null) => {
  const response = await axios.put(`${API_URL}/Transactions/${id}/reject`, {
    approvedBy, // Legacy (can be null)
    rejectionReason,
    notes,
    adminId,    // Current admin ID
    adminName   // Current admin name
  });
  return response.data;
};
